import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import NewModal from "../Reusable/NewModal";
import Spinner from "../Reusable/Spinner";
import TextField from "../Reusable/TextInput";
import ChangeStatus from "./ChangeStatus";
import { getKey } from "../../helpers/sessionKey";
import Modal from "../Reusable/Modal";
import ChangeOrderStatus from "./ChangeOrderStatus";

const EditRunsheet = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [statusList, setStatusList] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const [showMarkAsDoneModal, setShowMarkAsDoneModal] = useState(false);
  const [showMarkAsUnDoneModal, setShowMarkAsUnDoneModal] = useState(false);
  const [orderRemoveMenu, setOrderRemoveMenu] = useState(false);
  const isSuperUser = getKey("is_superuser");

  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    handleToggleMarkAsDone,
    handleRemove,
    isRemoved,
    isPrintLoading,
    handlecheckConsignments,
    gridData,
    handleStatusChange,
    defaultValue,
    isMarkAsDoneLoading,
    id,
    handleToggleMarkAsUnDone,
    setISactive,
    isactive,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createRunsheetValidationForm),
    defaultValues: async () => {
      return {
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        vehicle: {
          name: data?.vehicle?.license_number,
          id: data?.vehicle?.id,
        },
        destination_branch: {
          name: data?.destination_branch?.name,
          id: data?.destination_branch?.id,
        },
        note: data?.note,
      };
    },
  });
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      if (!data?.is_active) {
        handlecheckConsignments(event.target.value, setError);
      } else if (statusData?.length > 1 && defaultValue?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          defaultValue[0]?.id,
          setError
        );
      } else if (statusData?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          statusData[0]?.id,
          setError
        );
      } else {
        toast.error("Please select one status first");
      }
      event.target.value = "";
    }
  };
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };
  const defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Vendor",
      accessorKey: "order.vendor.user.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },

    {
      header: "Customer",
      accessorKey: "order.receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs`}>
              {row?.original?.order?.receiver?.primary_contact}
            </p>
            <p className={tw`text-xs`}>
              {row?.original?.order?.receiver?.address}
            </p>
          </>
        );
      },
    },

    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Weight",
      accessorKey: "order.weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {row?.original?.order?.package_type?.unit === "Gm"
                ? Number(getValue() * 1000) || 0
                : getValue() || 0}
              <span className="text-gray-500 text-xs">
                {row?.original?.order?.package_type?.unit}
              </span>
            </p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "order.delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.order?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
          </>
        );
      },
    },
  ];
  const deliveredColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Vendor",
      accessorKey: "vendor.user.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: NACell,
    },

    {
      header: "Customer",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs`}>
              {row?.original?.receiver?.primary_contact}
            </p>
            <p className={tw`text-xs`}>{row?.original?.receiver?.address}</p>
          </>
        );
      },
    },

    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: NACell,
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {row?.original?.order?.package_type?.unit === "Gm"
                ? Number(getValue() * 1000) || 0
                : getValue() || 0}
              <span className="text-gray-500 text-xs">
                {row?.original?.order?.package_type?.unit}
              </span>
            </p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
          </>
        );
      },
    },
  ];

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  useEffect(() => {
    if (gridData) {
      setStatusList(gridData?.results);
    }
  }, [gridData]);

  useEffect(() => {
    {
      statusList?.map((x) => {
        if (x?.name === "Intermediate") {
          setStatusData(x?.status_id);
        }
      });
    }
  }, [statusList]);

  const handleMarkAsDoneModalClose = () => {
    setShowMarkAsDoneModal(false);
  };
  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={!data?.is_active}
          >
            <div className={tw`grid md:grid-cols-3 gap-x-4 mx-4`}>
              <ComboboxInput
                url={APIS.VEHICLE}
                queryKey={"vehicle"}
                register={register("vehicle")}
                errors={errors?.vehicle}
                name={"vehicle"}
                label={"Vehicle Number"}
                setValue={setValue}
                placeholder={"Search vehicle"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <ComboboxInput
                url={APIS.DRIVER}
                queryKey={"driver"}
                register={register("driver")}
                errors={errors?.driver}
                name={"driver"}
                label={"Driver"}
                setValue={setValue}
                placeholder={"Search driver"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={"branch"}
                register={register("destination_branch")}
                errors={errors?.destination_branch}
                name={"destination_branch"}
                label={"Branch"}
                setValue={setValue}
                placeholder={"Search branch"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
            </div>
            <div className={tw`mx-4`}>
              <TextField
                label={"Note"}
                register={register(`note`, { disabled: !data?.is_active })}
                errors={errors?.note}
              />
            </div>
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_runsheet"]}
        renderNoAccess={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={true}
          >
            <div className={tw`grid md:grid-cols-3 gap-x-4 mx-4`}>
              <ComboboxInput
                url={APIS.VEHICLE}
                queryKey={"vehicle"}
                register={register("vehicle")}
                errors={errors?.vehicle}
                name={"vehicle"}
                label={"Vehicle Number"}
                disabled={true}
                setValue={setValue}
                placeholder={"Search vehicle"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <ComboboxInput
                url={APIS.DRIVER}
                queryKey={"driver"}
                register={register("driver")}
                errors={errors?.driver}
                name={"driver"}
                label={"Driver"}
                disabled={true}
                setValue={setValue}
                placeholder={"Search driver"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={"branch"}
                register={register("destination_branch")}
                errors={errors?.destination_branch}
                name={"destination_branch"}
                label={"Branch"}
                setValue={setValue}
                placeholder={"Search branch"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={true}
              />
            </div>
            <div className={tw`mx-4`}>
              <TextField
                label={"Note"}
                disabled={true}
                register={register(`note`, { disabled: !data?.is_active })}
                errors={errors?.note}
              />
            </div>
          </FormLayout>
        }
      />
      <Card title="Barcode Scanner">
        <>
          <div className={tw`flex flex-col relative -top-6 items-end w-full`}>
            <ChangeStatus
              handleAttachConsignment={handleAttachConsignment}
              gridData={statusData}
              handleStatusChange={handleStatusChange}
            />

            <div className={tw`grid grid-cols-1 w-full`}>
              <div>
                <input
                  type="text"
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                  onPaste={preventCopyPaste}
                  onKeyDown={handleKeyDown}
                />
                {errors?.tracking_number && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.tracking_number?.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      </Card>
      <DataTable
        url={
          isactive === "delivered"
            ? `${APIS.RUNSHEET}${id}/delivered-order/`
            : APIS.RUNSHEET_ITEMS
        }
        queryKey={`runsheet-items-${isactive}`}
        columns={isactive === "delivered" ? deliveredColumns : defaultColumns}
        params={{ manifest: data?.id }}
        tableName={"runsheet-items"}
        actionMenu={
          <div className={tw`w-full flex justify-between items-center`}>
            <div className={tw`flex border mr-2 rounded-full`}>
              {["all", "delivered"].map((type) => (
                <button
                  key={type}
                  onClick={() => setISactive(type)}
                  className={classNames(
                    tw`focus:outline-none rounded-full whitespace-nowrap py-2 px-6 capitalize`,
                    isactive === type ? tw`bg-primary text-white ` : ""
                  )}
                >
                  {type}
                </button>
              ))}
            </div>
            <div className={tw``}>
              {data?.is_active ? (
                <button
                  className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={() => setShowMarkAsDoneModal(true)}
                  disabled={!setShowMarkAsDoneModal}
                >
                  Mark As Done
                </button>
              ) : isSuperUser === "true" ? (
                <button
                  className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                  onClick={() => setShowMarkAsUnDoneModal(true)}
                  disabled={!setShowMarkAsUnDoneModal}
                >
                  Revert
                </button>
              ) : null}
              <button
                className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                disabled={isPrintLoading}
                onClick={() => handlePrint()}
              >
                {isPrintLoading ? <Spinner /> : "Print"}
              </button>
              {data?.is_active ? (
                <button
                  className={tw`p-1 px-5  rounded-sm border border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 `}
                  disabled={isRemoved}
                  onClick={() => {
                    setOrderRemoveMenu(true);
                    // handleRemove();
                  }}
                >
                  {isRemoved ? <Spinner /> : "Remove"}
                </button>
              ) : null}
            </div>
          </div>
        }
      />
      <NewModal
        isOpen={showMarkAsDoneModal}
        setIsOpen={setShowMarkAsDoneModal}
        showTitle={false}
      >
        <div className={tw`grid place-items-center w-fit`}>
          <div className={tw`space-y-3`}>
            <h2 className={tw`text-xl font-bold text-center`}>Are you sure?</h2>
            <div className={tw`flex items-center gap-5 justify-end`}>
              <button
                className={tw`bg-gray-200 rounded-lg px-2 py-2 focus:outline-none`}
                onClick={handleMarkAsDoneModalClose}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleToggleMarkAsDone();
                  setShowMarkAsDoneModal(false);
                }}
                className={tw`px-2 py-2 rounded-lg bg-primary  text-white disabled:bg-primary-light`}
                disabled={isMarkAsDoneLoading}
              >
                <p>Mark As done</p>
              </button>
            </div>
          </div>
        </div>
      </NewModal>
      <NewModal
        isOpen={showMarkAsUnDoneModal}
        setIsOpen={setShowMarkAsUnDoneModal}
        showTitle={false}
      >
        <div className={tw`grid place-items-center `}>
          <div className={tw`space-y-3`}>
            <h2 className={tw`text-xl font-bold text-center`}>Are you sure?</h2>
            <div className={tw`flex items-center gap-5 justify-end`}>
              <button
                className={tw`bg-gray-200 rounded-lg px-3 py-2 focus:outline-none`}
                onClick={() => setShowMarkAsUnDoneModal(false)}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleToggleMarkAsUnDone();
                  setShowMarkAsUnDoneModal(false);
                }}
                className={tw`px-6 py-2 rounded-lg bg-primary  text-white disabled:bg-primary-light`}
                disabled={isMarkAsDoneLoading}
              >
                <p>Yes</p>
              </button>
            </div>
          </div>
        </div>
      </NewModal>
      <NewModal
        isOpen={orderRemoveMenu}
        setIsOpen={setOrderRemoveMenu}
        title={"Change Status before Remove"}
      >
        <ChangeOrderStatus handleRemove={handleRemove} isLoading={isRemoved} />
      </NewModal>
    </>
  );
};
export default EditRunsheet;
